import WalletLoginModal from './WalletLoginModal.container'

export default WalletLoginModal
